/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Test_RequiredInputs */



/**
* | output |
* | --- |
* | "Test the connection before you continue." |
*
* @param {Spaces_Modular_Wizard_Test_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_test_required = /** @type {((inputs?: Spaces_Modular_Wizard_Test_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Test_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Testen Sie die Verbindung, bevor Sie fortfahren.")
	return /** @type {LocalizedString} */ ("Test the connection before you continue.")
});